module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbar-container"
  }, [_c('xy-tabbar-item', {
    attrs: {
      "iconName": "tab-loan-icon",
      "tabTitle": "贷款"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickItem(0)
      }
    }
  }), _vm._v(" "), _c('xy-tabbar-item', {
    attrs: {
      "iconName": "tab-boon-icon",
      "tabTitle": "福利活动"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickItem(1)
      }
    }
  }), _vm._v(" "), _c('xy-tabbar-item', {
    attrs: {
      "iconName": "tab-me-icon",
      "tabTitle": "我的"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickItem(2)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cd9022c!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/common/xy-tabbar.vue
// module id = 392
// module chunks = 36